/* eslint-disable @typescript-eslint/no-extra-semi */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Improved error base class.
 *
 * Needed for isinstance to work on your custom error instances.
 *
 * See https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
 *
 * borrowed from https://github.com/jamesadarich/extendo-error/blob/master/src/extendo-error.ts
 *
 */
export class BaseError implements Error {
  private _message: string
  public get message(): string {
    return this._message
  }
  public set message(message: string) {
    this._message = message
  }

  public get name(): string {
    return this.constructor.name
  }

  public constructor(message: string) {
    this._message = message
  }
}

Object.setPrototypeOf(BaseError.prototype, Error.prototype)
